import type { FC } from "react";
import { Switch as AriaSwitch } from "react-aria-components";
import { twMerge } from "tailwind-merge";

interface SwitchProps {
  isSelected: boolean;
  onChange: (isSelected: boolean) => void;
  isDisabled?: boolean;
  label?: string;
  /** Accessible name for switches rendered without a visible `label`
   * (e.g. an enable toggle in a table row). */
  accessibleLabel?: string;
}

export const Switch: FC<SwitchProps> = ({
  isSelected,
  onChange,
  isDisabled,
  label,
  accessibleLabel,
}) => (
  <AriaSwitch
    isSelected={isSelected}
    onChange={onChange}
    isDisabled={isDisabled}
    aria-label={accessibleLabel}
    className="group flex w-fit cursor-pointer items-center gap-2 disabled:cursor-not-allowed"
  >
    <span
      aria-hidden
      className={twMerge(
        "flex h-5 w-9 shrink-0 items-center rounded-full p-0.5 transition-colors duration-150",
        "bg-gray-200 group-selected:bg-indigo-600",
        "group-focus-visible:ring-2 group-focus-visible:ring-indigo-500 group-focus-visible:ring-offset-2",
        "group-disabled:opacity-50",
      )}
    >
      <span className="size-4 rounded-full bg-white shadow-xs transition-transform duration-150 group-selected:translate-x-4" />
    </span>
    {label ? <span className="text-sm text-foreground">{label}</span> : null}
  </AriaSwitch>
);
